// extracted by mini-css-extract-plugin
export default {"wrapper":"N3-z","play":"O3-z"};